const cases = [
  {
    type: "大学教授",
    title: "深度研究模式",
    desc: "使用深度研究模式，系统梳理领域文献，3 天完成万字级完整综述。",
    result: "3 天完成领域综述（原来需要 3 周）",
    icon: "ri-graduation-cap-line",
  },
  {
    type: "研究团队",
    title: "科学工具",
    desc: "使用 ScienceOne 科学工具进行复杂计算，批量处理实验数据，大幅提升效率。",
    result: "计算时间从周级压缩到小时级",
    icon: "ri-group-line",
  },
  {
    type: "博士生",
    title: "选题研判",
    desc: "通过平台选题研判功能快速锁定研究空白，借助 AI 评估选题新颖性，确定创新方向。",
    result: "快速锁定研究空白，确定创新方向",
    icon: "ri-user-star-line",
  },
];

const ecosystem = [
  { type: "高校", title: "某 985 高校", desc: "共建 AI 科研平台，推动学科建设与人才培养", result: "共建 AI 科研平台", icon: "ri-building-2-line" },
  { type: "科研院所", title: "国家重点实验室", desc: "联合研究项目，共同攻克前沿科学难题", result: "联合研究项目", icon: "ri-flask-line" },
  { type: "企业", title: "头部科技企业", desc: "定制化科研解决方案，赋能企业研发创新", result: "定制化科研解决方案", icon: "ri-building-4-line" },
];

const partnerTags = ["模型共建", "定制部署", "API 开放", "联合研究"];

export default function CasesSection() {
  return (
    <>
      {/* Cases */}
      <section id="cases" className="py-24 bg-[#080808]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-14">
            <div className="inline-block text-xs text-[#3d69e8] font-medium tracking-widest uppercase mb-4">应用案例</div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">他们的发现，从 ScienceOne 开始</h2>
            <div className="w-12 h-0.5 bg-[#3d69e8] mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {cases.map((c, i) => (
              <div key={i} className="bg-[#111111] border border-white/8 rounded-2xl p-6 flex flex-col">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#3d69e8]/10 border border-[#3d69e8]/20">
                    <i className={`${c.icon} text-base text-[#3d69e8]`}></i>
                  </div>
                  <span className="text-xs text-white/40 bg-white/5 px-3 py-1 rounded-full">{c.type}</span>
                </div>
                <h3 className="text-base font-semibold text-white mb-2">{c.title}</h3>
                <p className="text-sm text-white/50 leading-relaxed flex-1 mb-5">{c.desc}</p>
                <div className="flex items-center gap-2 bg-[#3d69e8]/5 border border-[#3d69e8]/15 rounded-xl px-4 py-3">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#3d69e8] text-sm"></i>
                  </div>
                  <span className="text-xs text-white/60">{c.result}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ecosystem */}
      <section className="py-24 bg-[#0a0a0a]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-14">
            <div className="inline-block text-xs text-[#3d69e8] font-medium tracking-widest uppercase mb-4">生态联盟</div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">与 ScienceOne 同行</h2>
            <div className="w-12 h-0.5 bg-[#3d69e8] mx-auto mb-4"></div>
            <p className="text-sm text-white/40">与高校、科研机构、企业共建，推动科研新范式</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {ecosystem.map((e, i) => (
              <div key={i} className="bg-[#111111] border border-white/8 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/5">
                    <i className={`${e.icon} text-base text-white/50`}></i>
                  </div>
                  <span className="text-xs text-white/30 bg-white/5 px-3 py-1 rounded-full">{e.type}</span>
                </div>
                <h3 className="text-base font-semibold text-white mb-2">{e.title}</h3>
                <p className="text-sm text-white/50 leading-relaxed mb-4">{e.desc}</p>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#3d69e8] text-sm"></i>
                  </div>
                  <span className="text-xs text-white/40">{e.result}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-5 bg-[#111111] border border-white/8 rounded-2xl px-8 py-6">
            <div>
              <div className="text-xs text-white/30 mb-3">合作方式</div>
              <div className="flex flex-wrap gap-2">
                {partnerTags.map((tag, i) => (
                  <span key={i} className="text-xs bg-white/5 border border-white/10 text-white/60 px-3 py-1.5 rounded-full">{tag}</span>
                ))}
              </div>
            </div>
            <a href="#" className="text-sm font-medium bg-white/5 hover:bg-white/10 border border-white/15 text-white px-5 py-2.5 rounded-lg transition-colors cursor-pointer no-underline whitespace-nowrap">
              联系我们
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
